import script from "./CapexAccountEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CapexAccountEditor.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__